<script setup>
import { EventManager, Actions, Events, ChangeSectionPayload } from "@events";
import { SectionList } from "@module-system";
import { useVideoCallState } from "@/stores/videoCallState";
import { onMounted, ref } from "vue";

import ChatInput from "./ChatInput.vue";

let actionEmitter = null;
let eventEmitter = null;
let state = null;
let loading = ref(false);



const props = defineProps({
  rtcId: {
    type: String,
    required: true,
  },
});

const messages = ref([]);

let scrollTimer = null;
function scrollBottom() {
  clearTimeout(scrollTimer);
  scrollTimer = setTimeout(() => {
    const chatArea = document.getElementById("chat-area");
    if (!chatArea) return;
    chatArea.scroll(0, chatArea.scrollHeight);
  }, 100);
}

const audioPlayer = {
  //  audio source https://pixabay.com/sound-effects/notifications-sound-127856/
  audio: new Audio("/new-message.mp3"),
  play: function () {
    this.audio.currentTime = 0;
    this.audio.play();
  },
};

onMounted(() => {
  state = useVideoCallState(props.rtcId);
  actionEmitter = EventManager.getActionEmitter(props.rtcId);
  eventEmitter = EventManager.getEventEmitter(props.rtcId);


  actionEmitter.addListener(Actions.OpenChatPanel, async () => {
    loading.value = false;
    console.info("ChatPanel: OpenChatPanel");
  });

  eventEmitter.addListener(
    Events.SignalingMessageReceived,
    async (response) => {
      if (response.type != "text-chat") return;
      loading.value = false;
      actionEmitter.emit(
        Actions.ChangeSectionModule,
        new ChangeSectionPayload({
          section: SectionList.CallRightPanel,
          key: "chat-panel",
        })
      );
      messages.value.push({
        content: response.data.message,
        me: false,
        type: response.data.messageType,
        createdAt: new Date(response.data.createdAt),
      });
      audioPlayer.play();
      scrollBottom();
    }
  );

  eventEmitter.addListener(Events.SignalingMessageSent, async (response) => {
    if (response.type != "text-chat") return;
    messages.value.push({
      content: response.data.message,
      me: true,
      type: response.data.messageType,
      createdAt: new Date(response.data.createdAt),
    });
    scrollBottom();
  });
});
</script>

<template>
  <div class="chatContainer">
    <div class="chatMessagesContainer" id="chat-area">
      <template :key="i" v-for="(msg, i) in messages">
        <div :class="{ 'd-flex flex-row-reverse': msg.me }">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-hover>
                <v-chip
                  :color="msg.me ? 'primary' : ''"
                  dark
                  style="height: auto; white-space: normal"
                  class="pa-4 mb-2"
                  @on="on"
                >
                  <template v-if="msg.type === 'text'">
                    {{ msg.content }}
                  </template>
                  <v-btn
                    :href="`/api/fileshare/download/${msg.content}`"
                    target="_blank"
                    v-else-if="msg.type === 'file'"
                  >
                    <v-icon>mdi-file</v-icon>
                    <sub class="ml-2">{{ 
                      msg.content.split("/").pop().length > 35 ? 
                      msg.content.split("/").pop().slice(0, 20) + "..." + msg.content.split("/").pop().slice(-15)
                      :
                      msg.content.split("/").pop()
                    }}</sub>
                  </v-btn>
                  <sub class="ml-2" style="font-size: 0.7rem">{{
                    new Date(msg.createdAt).toLocaleTimeString()
                  }}</sub>
                </v-chip>
              </v-hover>
            </template>
          </v-menu>
        </div>
      </template>
    </div>
    <div class="chatInputContainer">
      <ChatInput
        :rtcId="props.rtcId"
        :sender="state?.role"
        :senderName="state?.name"
        :eventEmitter="eventEmitter"
      />
    </div>
  </div>
</template>

<style>
.chatMessagesContainer {
  flex: 1 1 100%;
  overflow-y: auto;
  padding: 10px;
}

.chatContainer {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.chatInputContainer {
  flex: 1 1 0px;
  padding: 10px;
}
</style>
